<div class="cadastro-cnpj-oficina" ngxUiLoaderBlurred [loaderId]="'loader-principal'">
    <div class="corpo-pagina col-md-8 offset-md-2">
        <div class="card card-default">
            <app-support-gridview [config]="config" (onEdit)="onEdit($event)" (onRemove)="onRemove($event)"></app-support-gridview>
        </div>
    </div>
</div>
